import { render, staticRenderFns } from "./TokenUsages.vue?vue&type=template&id=1fa32662"
import script from "./TokenUsages.vue?vue&type=script&lang=js"
export * from "./TokenUsages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports